module.exports = __webpack_public_path__ + "static/media/MattW.e9e99d4c.jpg";